/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-comment-textnodes */
import {
  Button,
  Space,
  Drawer,
  message,
  Badge,
} from 'antd';
import moment from 'moment';
import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useMemo } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { DrawerHeader, Header, MoreMenu, TabsHeader } from 'datastake-daf/dist/components';
import Loading from "../../Loading";
import ProjectCreate from './create';
import ProjectsTab from "./projects";
import InvitationsTab from "./invitations";
import { actions } from '../../../store/reducers/project';
import { findOptions } from "../../../helpers/StringHelper";
import SubjectTableLayout from "../../Layout/SubjectTableLayout";
import { usePermissions } from "../../../permissions/usePermissions";
import { actions as authenticationActions } from '../../../store/reducers/authentication';
import { renderBreadCrumbs } from '../../../helpers/breadCrumbs';
import { CREATE_DRAWER_WIDTH } from '../../../helpers/form';

const mstp = ({ authentication, location, project }) => ({ authentication, location, project });

export const getHeaderColumns = (t, goTo, ChangeProjectStatus, module, push, changeProject, canPublish) => [
  {
    title: t('Project ID'),
    dataIndex: 'projectId',
    key: 'projectId',
    // render: (projectId, all) => all.empty ? null : (
    //   <NavLink className="projectLink" to={`/app/${module}/viewdd/project/${projectId}`}>
    //     {projectId}
    //   </NavLink>
    // ),
    render: (projectId, all) => all.empty ? null : projectId,
    search: true,
    invitation: true,
    client: true,
  },
  {
    title: t('Project Country'),
    dataIndex: 'country',
    key: 'country',
    search: true,
    invitation: true,
    client: true,
  },
  {
    title: t('Project Name'),
    dataIndex: 'name',
    key: 'name',
    primarySearch: true,
    invitation: true,
    client: true,
  },
  {
    title: t('Invited As'),
    dataIndex: 'role',
    key: 'role',
    invitation: true,
    projects: false,
  },
  {
    title: t('Invited By'),
    dataIndex: 'invitedOrgName',
    key: 'invitedOrgName',
    invitation: true,
    projects: false,
  },
  {
    title: t('Last Update'),
    dataIndex: 'lastUpdate',
    key: 'lastUpdate',
    defaultSortOrder: 'ascend',
    client: true,
  },
  {
    title: t(''),
    key: 'actions',
    width: 60,
    render: (row, all) => {
      if (all.empty) {
        return <div className="daf-default-cell" />;
      }

      const items = [
        {
          label: t('Project Details'),
          onClick: () => push(`/app/${module}/viewdd/project/${all.projectId}`),
          key: "details",
        },
        canPublish ? {
          key: "publish",
          onClick: () => push(`/app/${module}/project/${all.projectId}/publications`),
          label: t('Publish Data'),
        } : null,
        {
          key: "dashboard",
          onClick: () => changeProject(all),
          label: t('View Summary'),
        },
      ]

      return <MoreMenu items={items} />;
    },
    client: false,
  },
  {
    title: '',
    dataIndex: 'actions',
    key: 'actions',
    render: (row, item) => {
      if (item.empty) {
        return <div className="daf-default-cell" />;
      }

      return (
        <Space style={{ width: 'fit-content' }}>
          <Button size="small" type="primary" onClick={() => {
            ChangeProjectStatus({ id: item.dbId, invitedBy: item.invitedBy, role: item.roleId, status: 'approved' }, (type, data) => {
              message.success(t('Project approved'));
            });
          }}>{t('Approve')}</Button>
          <Button size="small" onClick={() => {
            ChangeProjectStatus({ id: item.dbId, invitedBy: item.invitedBy, role: item.roleId, status: 'rejected' }, (type, data) => {
              message.success(t('Project rejected'));
            });
          }}>{t('Reject')}</Button>
        </Space>
      )
    },
    width: 100,
    invitation: true,
    projects: false,
    client: true,
  },
]

const PER_PAGE = 10;

function Projects({
  authentication: { user },
  project: { data: { projects: data = [], options: projectOptions } },
  ProjectsGet,
  ResetProjectForm,
  ChangeProjectStatus,
  module,
  namespace,
  changeSelectedProjectAndSourceId,
}) {
  const { t } = useTranslation();
  const push = useNavigate();
  const { tab } = useParams();
  const { search } = useLocation();
  const [activeTab, setActiveTab] = useState(null);
  const [projects, setProjects] = useState([]);
  const [invitations, setInvitations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [createVisible, setCreateVisible] = useState(search.indexOf('create') !== -1 || search.indexOf('edit') !== -1);
  const { canPublish, canCreate, canEdit } = usePermissions({ permission: 'projects', defaultValue: {} });
  const dispatch = useDispatch();
  const { invitations: invData } = useSelector((state) => state.project);

  const _changeProject = (p) => {
    localStorage.removeItem('source');
    localStorage.setItem('project', p.dbId)
    changeSelectedProjectAndSourceId(p.dbId, 'overview');
    push(`/app/${module}`);
  }

  const columns = getHeaderColumns(t, push, (payload, callback) => {
    setIsLoading(true);
    ChangeProjectStatus(payload, (type, data) => {
      callback(type, data);
      setIsLoading(false);
      dispatch(actions.GetInvitedProjects());
    })
  }, module, push, _changeProject, canPublish);

  useEffect(() => {
    ProjectsGet({ namespace, module, view: 'project' });
    dispatch(actions.GetInvitedProjects());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tab) {
      setActiveTab(tab);
    } else {
      setActiveTab('projects');
    }
  }, [tab]);

  const updateProjects = () => {
    if (data && Array.isArray(data)) {
      const { countries } = projectOptions || {};
      const userProjects = user.projects;
      if (userProjects.length) {
        const allProjects = userProjects.map(p => {
          const project = data.find(pr => pr.id === p.projectId);
          if (!project) {
            return undefined;
          }
          return {
            key: project.id,
            dbId: project.id,
            projectId: project.datastakeId,
            invitedBy: p.invitedBy,
            invitedOrgName: p.invitedOrgName,
            roleId: p.role,
            role: p.role === 'customer' ? t('Data Client') : t('Information Source'),
            country: project.country ? findOptions(project.country, countries) : '-',
            status: p.status,
            name: project.name ? project.name : '',
            // dataClient: project.name && project.surname ? `${project.name} ${project.surname}` : '-',
            lastUpdate: project.publishedAt ? moment(project.publishedAt).format('DD MMM YYYY') : (
              project.updatedAt ? moment(project.updatedAt).format('DD MMM YYYY') : '-'
            ),
            contactName: project.name ? project.name : '-',
          };
        }).filter(p => p);
        setProjects([...allProjects.filter(p => p.status === 'approved').filter((p, index, self) => index === self.findIndex(s => s.dbId === p.dbId))]);
      }
    }
  }

  useEffect(() => {
    updateProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])


  const updateInvitatedProjects = () => {
    if (invData && Array.isArray(invData)) {
      const { countries = [] } = projectOptions || {};
      const allInvitedProjects = invData.map(project => {
        return {
          key: `${project.id}-${project.role}`,
          dbId: project.id,
          projectId: project.datastakeId,
          invitedBy: project.invitedBy,
          invitedOrgName: project.invitedOrgName,
          roleId: project.role,
          role: project.role === 'customer' ? t('Data Client') : t('Information Source'),
          country: project.country ? findOptions(project.country, countries) : '-',
          status: project.status,
          name: project.name ? project.name : '',
          // dataClient: project.name && project.surname ? `${project.name} ${project.surname}` : '-',
          lastUpdate: project.publishedAt ? moment(project.publishedAt).format('DD MMM YYYY') : (
            project.updatedAt ? moment(project.updatedAt).format('DD MMM YYYY') : '-'
          ),
          contactName: project.name ? project.name : '-',
        };
      }).filter(p => p);
      setInvitations([...allInvitedProjects.filter(p => p.status === 'pending').filter((p, index, self) => index === self.findIndex(s => s.key === p.key))]);
    }
  }

  useEffect(() => {
    updateInvitatedProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invData])

  const extraButtons = [];

  if (canCreate && tab !== 'invitations') {
    extraButtons.push({
      type: "primary",
      onClick: () => {
        ResetProjectForm({ view: "project" });
        setCreateVisible(true);
      },
      label: t("New")
    });
  }

  const breadCrumbs = useMemo(() =>
    renderBreadCrumbs({ t, view: 'projects', goTo: push, mod: module }), [t, push]);

  return !data || isLoading ? <Loading /> : (
    <SubjectTableLayout
      header={(
        <>
          <Header
            title={t("Projects")}
            actionButtons={extraButtons}
            breadcrumbs={breadCrumbs}
          />
          {activeTab ? (
            <TabsHeader
              value={activeTab}
              onChange={(key) => {
                if (key === 'projects') {
                  push(`/app/${module}/projects`)
                } else {
                  push(`/app/${module}/projects/${key}`)
                }
              }}
              tabs={[
                {
                  value: 'projects',
                  label: t("Projects"),
                },
                canEdit ? {
                  value: 'invitations',
                  label: (
                    <>
                      {t("Invitations")}
                      <Badge offset={[10, 0]} count={invitations.length} />
                    </>
                  ),
                } : null,
              ].filter((v) => !!v)}
            />

          ) : null}
        </>
      )}
    >
      {activeTab === 'projects' && (
        <ProjectsTab
          columns={columns}
          projects={projects}
          perPage={PER_PAGE}
        />
      )}
      {activeTab === 'invitations' && (
        <InvitationsTab
          columns={columns}
          data={invitations || []}
          perPage={PER_PAGE}
        />
      )}
      <Drawer
        destroyOnClose={true}
        title={<DrawerHeader title={t('Create Project')} />}
        open={createVisible && canEdit}
        maskClosable={false}
        onClose={() => {
          setCreateVisible(false);
          ResetProjectForm({ view: ["project", "new"], module })
          ProjectsGet({ namespace, module, view: 'project' });
        }}
        width={CREATE_DRAWER_WIDTH}
        bodyStyle={{ padding: 0 }}>
        <ProjectCreate
          namespace={namespace}
          showSaveAndNext={false}
          module={module}
          view={["project", "new"]}
          edit={false}
          onSubmitted={(type, m, _payload) => {
            if (_payload && _payload.data) {
              const { data } = _payload;
              push(`/app/${module}/editdd/project/${data.datastakeId}`);
              return;
            }

            message.success(t('Information submitted successfully'));
            setCreateVisible(false);
            ResetProjectForm({ view: ["project", "new"] })
            ProjectsGet({ namespace, module, view: 'project' });
          }}
          onCancel={() => setCreateVisible(false)} />
      </Drawer>
    </SubjectTableLayout>
  );
}


export default connect(mstp, { ...actions, ...authenticationActions })(Projects);
